import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";

import { validation, formfields } from "kea-react"

type Entity = models.ParamsEnviosCanalComercializacion;

export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class EnviosCanalComercializacion extends React.PureComponent<{}, State> {
      constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

   errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaDesde: validation.required,
            FechaHasta: validation.required,
        };
    }

    onGenerarEstadisticasClientes = async () => {
        const reporte = await resources.RepEnviosCanalComercializacion.Generar(this.state.value);
        await kea.download(reporte, "Reporte envíos canal de comercialización.xls");
    }

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        return (
            <div>
                <kea.Title titulo="Reporte de envíos por canal de comercialización" onRegresar={() => history.go("../")} />                
                {kea.autogrid(6, [
                    <DateTime field="FechaDesde" label="Fecha desde" />,
                    <DateTime field="FechaHasta" label="Fecha hasta" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarEstadisticasClientes} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteenvioscanalcomercializacion/index.tsx